export default "__VITE_ASSET__DHojamPX__"